<template lang="pug">
.m-card
  .m-card-header(:id="'heading-tw-' + id" :data-bs-target="'#collapse-tw-' + id" :aria-controls="'collapse-tw-' + id" data-bs-toggle='collapse' role='button' aria-expanded='false')
    .group
      .league-name {{ $tc("m.BT_1X2HDP", 1) }}
  .m-card-body.collapse.show(:id="'collapse-tw-' + id" :aria-labelledby="'heading-tw-' + id" aria-expanded='false')
    .m-card-item(:class="{ 'live' : marketType == 3 }")
      .m-card-wrap
        .odds-wrapper(v-if="mode == 0 || mode == 1")
          .m-label-wrap
            .m-label F.T  
          .odds-group
            template(v-if="moreItems['tw'] && moreItems['tw'][0] && moreItems['tw'][0][5] != 0 && moreItems['tw'][0][5] != ''")
              OddsItem.col(:odds="moreItems['tw'][0]" idx=5 :typ="oddsType" dataType="2" :details="moreItems" :label="$t('m.BT_H') + ' (' + ballDisplay(1, 'tw') + ')'")
            template(v-else)
              OddsDisabled.col
            template(v-if="moreItems['tw'] && moreItems['tw'][0] && moreItems['tw'][0][6] != 0 && moreItems['tw'][0][6] != ''")
              OddsItem.col(:odds="moreItems['tw'][0]" idx=6 :typ="oddsType" dataType="2" :details="moreItems" :label="$t('m.BT_D') + ' (' + ballDisplay(3, 'tw') + ')'")
            template(v-else)
              OddsDisabled.col
            template(v-if="moreItems['tw'] && moreItems['tw'][0] && moreItems['tw'][0][7] != 0 && moreItems['tw'][0][7] != ''")
              OddsItem.col(:odds="moreItems['tw'][0]" idx=7 :typ="oddsType" dataType="2" :details="moreItems" :label="$t('m.BT_A') + ' (' + ballDisplay(2, 'tw') + ')'")
            template(v-else)
              OddsDisabled.col
        .odds-wrapper(v-if="$helpers.objSize(moreItems['twh']) > 0 && (mode == 0 || mode == 2)")
          .m-label-wrap
            .m-label H.T  
          .odds-group
            template(v-if="moreItems['twh'] && moreItems['twh'][0] && moreItems['twh'][0][5] != 0 && moreItems['twh'][0][5] != ''")
              OddsItem.col(:odds="moreItems['twh'][0]" idx=5 :typ="oddsType" dataType="2" :details="moreItems" :label="$t('m.BT_H') + ' (' + ballDisplay(1, 'twh') + ')'")
            template(v-else)
              OddsDisabled.col  
            template(v-if="moreItems['twh'] && moreItems['twh'][0] && moreItems['twh'][0][6] != 0 && moreItems['twh'][0][6] != ''")
              OddsItem.col(:odds="moreItems['twh'][0]" idx=6 :typ="oddsType" dataType="2" :details="moreItems" :label="$t('m.BT_D') + ' (' + ballDisplay(3, 'twh') + ')'")
            template(v-else)
              OddsDisabled.col  
            template(v-if="moreItems['twh'] && moreItems['twh'][0] && moreItems['twh'][0][7] != 0 && moreItems['twh'][0][7] != ''")
              OddsItem.col(:odds="moreItems['twh'][0]" idx=7 :typ="oddsType" dataType="2" :details="moreItems" :label="$t('m.BT_A') + ' (' + ballDisplay(2, 'twh') + ')'")
            template(v-else)
              OddsDisabled.col  





//- .card.market-card
//-   .card-header.bg-more-head.collapse-more(
//-     :id="'heading-tw-' + id"
//-     data-toggle='collapse'
//-     :data-target="'#collapse-tw-' + id"
//-     :aria-controls="'collapse-tw-' + id"
//-     aria-expanded=true
//-   )
//-     .flex-grow-1.text-ellipsis.text-uppercase.mr-2 {{ $tc("m.BT_1X2HDP", 1) }}
//-   .collapse.show(
//-     :aria-labelledby="'heading-tw-' + id"
//-     :id="'collapse-tw-' + id"
//-   )
//-     .card-body.p-0
//-       .market-card-content
//-         .normal(v-if="mode == 0 || mode == 1")
//-           .normal-title {{ $t("ui.full_time") }}
//-           .normal-odd-area
//-             .normal-odd-area-group
//-               .normal-odd-area-oddtype.text-center.mr-0 {{ $t("m.BT_H") }} ({{ ballDisplay(1, 'tw') }})
//-               template(v-if="moreItems['tw'] && moreItems['tw'][0] && moreItems['tw'][0][5] != 0 && moreItems['tw'][0][5] != ''")
//-                 OddsItem(:odds="moreItems['tw'][0]" idx=5 :typ="oddsType" dataType="2" :details="moreItems")
//-               template(v-else)
//-                 OddsDisabled
//-             .normal-odd-area-group
//-               .normal-odd-area-oddtype.text-center.mr-0 {{ $t("m.BT_D") }} ({{ ballDisplay(3, 'tw') }})
//-               template(v-if="moreItems['tw'] && moreItems['tw'][0] && moreItems['tw'][0][6] != 0 && moreItems['tw'][0][6] != ''")
//-                 OddsItem(:odds="moreItems['tw'][0]" idx=6 :typ="oddsType" dataType="2" :details="moreItems")
//-               template(v-else)
//-                 OddsDisabled
//-             .normal-odd-area-group
//-               .normal-odd-area-oddtype.text-center.mr-0 {{ $t("m.BT_A") }} ({{ ballDisplay(2, 'tw') }})
//-               template(v-if="moreItems['tw'] && moreItems['tw'][0] && moreItems['tw'][0][7] != 0 && moreItems['tw'][0][7] != ''")
//-                 OddsItem(:odds="moreItems['tw'][0]" idx=7 :typ="oddsType" dataType="2" :details="moreItems")
//-               template(v-else)
//-                 OddsDisabled
//-         .normal(v-if="$helpers.objSize(moreItems['twh']) > 0 && (mode == 0 || mode == 2)")
//-           .normal-title {{ $t("ui.half_time") }}
//-           .normal-odd-area
//-             .normal-odd-area-group
//-               .normal-odd-area-oddtype.text-center.mr-0 {{ $t("m.BT_H") }} ({{ ballDisplay(1, 'twh') }})
//-               template(v-if="moreItems['twh'] && moreItems['twh'][0] && moreItems['twh'][0][5] != 0 && moreItems['twh'][0][5] != ''")
//-                 OddsItem(:odds="moreItems['twh'][0]" idx=5 :typ="oddsType" dataType="2" :details="moreItems")
//-               template(v-else)
//-                 OddsDisabled
//-             .normal-odd-area-group
//-               .normal-odd-area-oddtype.text-center.mr-0 {{ $t("m.BT_D") }} ({{ ballDisplay(3, 'twh') }})
//-               template(v-if="moreItems['twh'] && moreItems['twh'][0] && moreItems['twh'][0][6] != 0 && moreItems['twh'][0][6] != ''")
//-                 OddsItem(:odds="moreItems['twh'][0]" idx=6 :typ="oddsType" dataType="2" :details="moreItems")
//-               template(v-else)
//-                 OddsDisabled
//-             .normal-odd-area-group
//-               .normal-odd-area-oddtype.text-center.mr-0 {{ $t("m.BT_A") }} ({{ ballDisplay(2, 'twh') }})
//-               template(v-if="moreItems['twh'] && moreItems['twh'][0] && moreItems['twh'][0][7] != 0 && moreItems['twh'][0][7] != ''")
//-                 OddsItem(:odds="moreItems['twh'][0]" idx=7 :typ="oddsType" dataType="2" :details="moreItems")
//-               template(v-else)
//-                 OddsDisabled
</template>

<script>
import OddsItem from "@/components/mobile/main/xitem/oddsItem";
import OddsDisabled from "@/components/mobile/main/xitem/oddsDisabled";
import mixinHDPOUOdds from "@/library/mixinHDPOUOdds";
import naming from "@/library/_name";

export default {
  components: {
    OddsItem,
    OddsDisabled
  },
  mixins: [mixinHDPOUOdds],
  props: {
    mode: {
      type: Number
    }
  },
  methods: {
    ballDisplay(b, mode) {
      if(this.moreItems[mode]) {
        return naming.ballDisplay3way(b, this.moreItems[mode][0][17], this);
      }
    }
  }
}
</script>
